var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var TriangleUpIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 56,
    glyphHeight: 34
  }), React.createElement("path", {
    d: "M24.3749 1.81627C26.3462 -0.258942 29.6539 -0.258939 31.6252 1.81627L54.1763 25.5564C57.2018 28.7414 54.9441 34 50.5512 34H5.44885C1.05597 34 -1.20176 28.7414 1.8237 25.5564L24.3749 1.81627Z"
  }));
};
export var TriangleUpIconGlyph = function (props) {
  return React.createElement(TriangleUpIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};